<template>
    <v-card id="STARMarketTable">
      <v-card-title style="display: grid; grid-auto-flow: row">
        <div v-if="selectedNfts.size > 0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge :content="selectedNfts.size" color="primary" offset-x="15" offset-y="15">
                <v-btn icon v-bind="attrs" v-on="on" @click="showMultiPurchaseDialog = true">
                  <v-icon>mdi-cart-check</v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>Purchase selected NFTs</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="deselectAllNfts">
                  <v-icon>mdi-cart-minus</v-icon>
                </v-btn>
            </template>
            <span>Deselect all</span>
          </v-tooltip>
        </div>

        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table dense :headers="headers" :items="nfts" :items-per-page="50" :loading="moreToLoad" :loading-text="'Loading... Please wait'"
                     :footer-props="{'items-per-page-options': [10, 50, 100, 1000, -1]}" multi-sort :search="search">

        <template v-slot:item.controls="{ item }" ref="'test' + item.nftId">
          <td>
            <div class="controlButtons">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn id="purchase-nft-btn" icon v-bind="attrs" v-on="on" @click="purchaseSingleNft(item)">
                    <v-icon>
                      mdi-currency-usd
                    </v-icon>
                  </v-btn>
                </template>
                <span>Purchase {{ item.grouping.type }}</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!selectedNfts.has(item.nftId)">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn id="add-nft-to-selection-btn" icon v-bind="attrs" v-on="on" @click="itemSelected(item)">
                    <v-icon>
                      mdi-cart-plus
                    </v-icon>
                  </v-btn>
                </template>
                <span>Select {{ item.grouping.type }}</span>
              </v-tooltip>
              <v-tooltip bottom v-else>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn id="remove-nft-from-selection-btn" icon v-bind="attrs" v-on="on" @click="itemSelected(item)">
                    <v-icon>
                      mdi-cart-minus
                    </v-icon>
                  </v-btn>
                </template>
                <span>Remove from selection</span>
              </v-tooltip>

            </div>
          </td>
        </template>
      </v-data-table>

      <PurchaseNFTsDialog :user="username" :table="table" :nfts="selectedNfts" v-if="showMultiPurchaseDialog"
                          @close-dialog="showMultiPurchaseDialog = false" @nfts-purchased="removePurchasedNfts($event)"/>
    </v-card>
</template>

<script>

import NftOperations from "../../../mixins/NftOperations";
import PurchaseNFTsDialog from "../../dialogs/PurchaseNFTsDialog";

export const TABLE = "STAR";

export default {
  name: 'STARMarketTable',
  components: {PurchaseNFTsDialog},
  props: ['username'],
  mixins: [NftOperations],
  mounted() {
    this.loadAll();
  },
  computed: {
  },
  data() {
    return {
      moreToLoad: false,
      table: TABLE,
      nfts: [],
      search: "",
      selectedNfts: new Map(),
      showMultiPurchaseDialog: false,
      headers: [
        {
          value: "nftId",
          filterable: true,
          text: "ID"
        },
        {
          value: "account",
          filterable: true,
          text: "Seller"
        },
        {
          value: "grouping.type",
          filterable: true,
          text: "Type"
        },
        {
          value: "grouping.class",
          filterable: true,
          text: "Class"
        },
        {
          value: "price",
          filterable: true,
          text: "Price"
        },
        {
          value: "priceSymbol",
          filterable: true,
          text: "Price Symbol"
        },
        {
          value: "controls",
          filterable: false,
          sortable: false,
          text: "Actions"
        }
      ]
    }
  },
  methods: {
    fetchTokens(contract, table, limit, offset) {
      this.$ssc.find(contract, table, {}, limit, offset, [], (err, result) => {
            result.forEach(item => {
              // Remove unwanted decimal places
              item.price = parseFloat(item.price);
              this.nfts.push(item);
            });
            return result;
          }).then(tokens => {
        if (tokens.length === 1000) {
          offset += 1000;
          this.moreToLoad = true;
          this.fetchTokens(contract, table, limit, offset);
        }
        else {
          this.moreToLoad = false;
        }
      });
    },
    loadAll() {
      this.moreToLoad = true;
      this.fetchTokens("nftmarket", TABLE + "sellBook", 1000, 0);
    },
    purchaseSingleNft(item) {
      this.purchaseNfts(this.username, TABLE, [item.nftId]);
    },
    // TODO: Probably rewrite this. Maybe do the icon update manually
    itemSelected(item) {
      if (!item.selected && this.selectedNfts.size >= 50) {
        this.$vToastify.error("You cannot select more than 50 NFTs in one transaction");
        return;
      }
      if (item.selected) {
        item.selected = !item.selected;
        this.selectedNfts.delete(item.nftId);
      }
      else {
        item.selected = true;
        this.selectedNfts.set(item.nftId, item);
      }
      this.$forceUpdate()
    },
    deselectAllNfts() {
      // TODO: There's still a bug here, you don't actually deselect them
      // You have to click them twice to be able to add them again
      for (let item of this.selectedNfts) {
        item.selected = false;
      }
      this.selectedNfts = new Map();
      this.$forceUpdate();
    },
    removePurchasedNfts(nftsToRemove) {
      this.nfts = this.nfts.filter( ( nft ) => !nftsToRemove.includes( nft.nftId ) );
      this.selectedNfts = new Map();
    }
  }
}
</script>

<style scoped>
.controlButtons {
  display: grid;
  grid-auto-flow: column;
  justify-items: center;
  align-items: center;
  justify-content: start;
  grid-gap: 5px;
}
</style>